import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { FOOTER_COLS } from "../data/site";
import { WHATSAPP_LINK, CONTACT_EMAIL } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-obsidian text-slate-300">
      <div className="mx-auto max-w-8xl px-4 pb-10 pt-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:gap-8">
          {FOOTER_COLS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-orange">
                {col.title}
              </p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-sm text-slate-400 transition-colors hover:text-white"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 flex flex-col gap-6 border-t border-white/10 pt-10 lg:flex-row lg:items-center lg:justify-between">
          <div className="space-y-4">
            <Logo />
            <p className="max-w-md text-sm leading-relaxed text-slate-400">
              Conectando você ao que importa. Descontos, serviços, entregas e oportunidades perto de você.
            </p>
            <p className="font-mono text-xs leading-relaxed text-slate-500">
              OFF360 TECNOLOGIA SERVICOS E SOLUCOES LTDA · CNPJ 69.590.691/0001-27
              <br />
              Campinas — São Paulo · www.off360.com.br
            </p>
          </div>
          <div className="space-y-3 text-sm">
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email-link"
              className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-brand-orange"
            >
              <Mail className="h-4 w-4 text-brand-orange" />
              {CONTACT_EMAIL}
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-brand-orange"
            >
              <MessageCircle className="h-4 w-4 text-brand-orange" />
              Suporte pelo WhatsApp: (11) 91749-3917
            </a>
            <p className="flex items-center gap-2.5 text-slate-400">
              <MapPin className="h-4 w-4 text-brand-orange" />
              Base de lançamento: Campinas, São Paulo
            </p>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6">
          <p className="text-xs text-slate-500">
            © 2026 OFF360. Todos os direitos reservados. O 360Taxi é o serviço principal da primeira fase;
            os demais recursos são futuros lançamentos e não estão disponíveis para uso ou contratação.
          </p>
        </div>
      </div>
    </footer>
  );
}
